import { deepFreeze } from '@util';
import { commonConstants } from 'adriel_backandfrontcommon';

import YtoneLogo from '../../public/static/assets/img/logos/logo_ytone.png';
import EcomLogo from '../../public/static/assets/img/logos/logo_ecom.png';
import AdfuelFullWhiteLogo from '../../public/static/assets/img/logos/full_logo_white_adfuel.webp';
import UnfiLogo from '../../public/static/assets/img/logos/logo_ecom_unfi.png';
import RocMediaFullWhiteLogo from '../../public/static/assets/img/logos/logo_roc_media_white.png';
import FinchFullWhiteLogo from '../../public/static/assets/img/logos/full_logo_white_finch.png';
import IrisFavicon from '../../public/static/assets/img/logos/favicon_iris.png';

export const USER_FLOW_ID = {
    KO: 'a498804a-d321-4af4-83c6-ae89f5146844',
    EN: 'ce2a3ab7-a12e-4f41-ad0f-7b4be2bcf032',
};

export const CONTACTS_FILE_TYPES = ['txt', 'csv']; //, 'xls', 'xlsx'];

export const ALREADY_EXIST = "There's already the same one";

export const CHANNELS = {
    GOOGLE: 'google',
    GOOGLE_DISPLAY: 'google_display',
    GOOGLE_SEARCH: 'google_search',
    GOOGLE_SHEETS: ' google_spreadsheet',
    GOOGLE_UNI_APP: 'google_universal_appstore',
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    FB_AND_INSTA: 'facebook+instagram',
    YOUTUBE: 'youtube',
    APPLE: 'apple',
    AMAZON: 'amazon',
    KAKAO: 'kakao',
    NAVER: 'naver',
    YELP: 'yelp',
    MICROSOFT: 'microsoft',
    LINKEDIN: 'linkedin',
    SNAPCHAT: 'snapchat',
    CRITEO: 'criteo',
    APPSFLYER: 'appsFlyer',
    YAHOO: 'yahoo',
    BRANCH: 'branch',
    PINTEREST: 'pinterest',
    APPSTORECONNECT: 'appStoreConnect',
    PLAYSTORE: 'playStore',
    REDDIT: 'reddit',
    NAVER_GFA: 'naverGFA',
    MAILCHIMP: 'mailchimp',
    WORKOS: 'workos',
};

export const ISO_WEEK_DATE_MAP = {
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
    7: 'sunday',
};

export const DOMESTIC_CHANNELS = [
    CHANNELS.KAKAO,
    CHANNELS.NAVER,
    CHANNELS.NAVER_GFA,
];

const NEW_CHANNELS = {
    UNITY_ADS: 'unityAds',
    INSTAGRAM_PUBLIC: 'instagramPublic',
    KAKAO_KEYWORDS_ADS: 'kakaoKeywordsAds',
    FACEBOOK_PAGE_ANAYTICS: 'facebookPageAnalytics',
    YOUTUBE_PUBLIC: 'youtubePublic',
    TIKTOK_PUBLIC: 'tiktokPublic',
    AIRTABLE: 'airtable',
    MY_SQL: 'mysql',
    POSTGRES: 'postgres',
    GOOGLE_SHEETS: 'googleSpreadSheet',
    AMAZON: 'amazon',
    PINTEREST: 'pinterest',
    WALMART: 'walmart',
};

export const NEW_SYSTEM_CHANNELS = R.values(NEW_CHANNELS);

export const CHANNEL_FILTER_LIST = [
    'facebook',
    'google',
    'kakao',
    'kakaoKeywordsAds',
    'naver',
    'apple',
    'amazon',
    'yelp',
    'microsoft',
    'linkedin',
    'twitter',
    'tiktok',
    'snapchat',
    'criteo',
    'yahoo',
    // 'branch',
    'pinterest',
    // 'appStoreConnect',
    // 'playStore',
    'reddit',
    'naverGFA',
    'mailchimp',
];

export const SUB_CHANNEL_FILTER_LIST = [
    ...commonConstants.GOOGLE_SUBCHANNELS,
    // ...commonConstants.FACEBOOK_SUBCHANNELS,
];

export const ALL_CHANNELS = [
    'all',
    CHANNELS.FACEBOOK,
    CHANNELS.INSTAGRAM,
    CHANNELS.GOOGLE,
    CHANNELS.APPLE,
    CHANNELS.KAKAO,
    CHANNELS.MICROSOFT,
    CHANNELS.YELP,
    CHANNELS.YOUTUBE,
];

export const SKIPPED_CHANNELS = [CHANNELS.YOUTUBE, CHANNELS.APPLE];

export const KR_CARD_MAP = {
    '01': 'bc',
    '02': 'kb',
    '03': 'hana',
    '04': 'samsung',
    '06': 'shinhan',
    '07': 'hyundai',
    '08': 'lotte',
    11: 'citi',
    12: 'nh',
    15: 'woori',
    16: 'hana',
};

export const IMG_CARDS = [
    'visa',
    'mastercard',
    'american express',
    'jcb',
    'unionpay',
    ...Object.values(KR_CARD_MAP),
];

export const UPLOADABLE_FILE_TYPE = '.xls, .xlsx, .csv, .pdf';

export const UPLOADABLE_IMAGE_TYPE = 'image/*';

export const UPLOADABLE_IMAGE_VIDEO_TYPE = 'image/*, video/*';

export const ANALYTICS_EVENT_NAMES = [
    'ViewContent',
    'Search',
    'AddToCart',
    'AddToWishlist',
    'InitiateCheckout',
    'AddPaymentInfo',
    'Purchase',
    'Lead',
    'CompleteRegistration',
];

export const FB_REQUEST_OPTION = {
    scope: 'email,manage_pages,business_management,ads_management,instagram_basic, ads_read',
    return_scopes: true,
};

export const TEL_PREFERRED = ['kr', 'us', 'fr', 'hk', 'sg', 'au'];

export const INVALID_KEYWORD =
    /^[\u00BF-\u1FFF\u2C00-\uD7FF\w#$&_ "+.,/:\-[\]']+$/;

export const CAMPAIGN_STATUS = {
    RUNNING: 'running',
    IN_REVIEW: 'in_review',
    IN_PROGRESS: 'in_progress',
    PROPOSAL_REVIEW: 'proposal_review',
    IN_REVIEW_EXPRESS: 'in_review_express',
    DEACTIVATED: 'deactivated',
    ONBOARDING: 'onboarding',
    SAMPLE: 'sample',
    SCHEDULED: 'scheduled',
    DISAPPROVED: 'disapproved',
};

export const FB_CTA_OPTIONS = [
    {
        text: 'COMMON.cta_fb_LEARN_MORE',
        value: 'LEARN_MORE',
    },
    {
        text: 'COMMON.cta_fb_SHOP_NOW',
        value: 'SHOP_NOW',
    },
    {
        text: 'COMMON.cta_fb_BOOK_TRAVEL',
        value: 'BOOK_TRAVEL',
    },
    {
        text: 'COMMON.cta_fb_LISTEN_NOW',
        value: 'LISTEN_NOW',
    },
    {
        text: 'COMMON.cta_fb_WATCH_VIDEO',
        value: 'WATCH_VIDEO',
    },
    {
        text: 'COMMON.cta_fb_SIGN_UP',
        value: 'SIGN_UP',
    },
    {
        text: 'COMMON.cta_fb_DOWNLOAD',
        value: 'DOWNLOAD',
    },
    {
        text: 'COMMON.cta_fb_WATCH_MORE',
        value: 'WATCH_MORE',
    },
    {
        text: 'COMMON.cta_fb_NO_BUTTON',
        value: 'NO_BUTTON',
    },
    {
        text: 'COMMON.cta_fb_APPLY_NOW',
        value: 'APPLY_NOW',
    },
    {
        text: 'COMMON.cta_fb_GET_OFFER',
        value: 'GET_OFFER',
    },
    {
        text: 'COMMON.cta_fb_SUBSCRIBE',
        value: 'SUBSCRIBE',
    },
    {
        text: 'COMMON.cta_fb_CONTACT_US',
        value: 'CONTACT_US',
    },
    {
        text: 'COMMON.cta_fb_ORDER_NOW',
        value: 'ORDER_NOW',
    },
    {
        text: 'COMMON.cta_fb_GET_SHOWTIMES',
        value: 'GET_SHOWTIMES',
    },
    {
        text: 'COMMON.cta_fb_PLAY_GAME',
        value: 'PLAY_GAME',
    },
    {
        text: 'COMMON.cta_fb_INSTALL_APP',
        value: 'INSTALL_APP',
    },
    {
        text: 'COMMON.cta_fb_USE_APP',
        value: 'USE_APP',
    },
    // {
    //     text: 'COMMON.cta_fb_DONATE',
    //     value: 'DONATE',
    // },
    {
        text: 'COMMON.cta_fb_GET_QUOTE',
        value: 'GET_QUOTE',
    },
];

export const GOOGLE_DISPLAY_CTA_OPTIONS = [
    'APPLY_NOW',
    'BOOK_NOW',
    'CONTACT_US',
    'DOWNLOAD',
    'LEARN_MORE',
    'INSTALL',
    'VISIT_SITE',
    'SHOP_NOW',
    'SIGN_UP',
    'GET_QUOTE',
    'SUBSCRIBE',
    'SEE_MORE',
];

export const KAKAO_IMAGE_CTA_OPTIONS = [
    '선택안함',
    '알아보기',
    '가입하기',
    '구매하기',
    '문의하기',
    '바로가기',
    '소식받기',
    '신청하기',
    '예약하기',
    '쿠폰받기',
];

export const KEY_CODE = {
    enter: 13,
    backspace: 8,
    tab: 9,
    shift: 16,
    ctrl: 17,
    alt: 18,
    capsLock: 20,
    esc: 27,
    up: 38,
    down: 40,
    comma: 188,
};

export const FB_AND_INSTA_SINGLE = {
    channel: CHANNELS.FB_AND_INSTA,
    creativeType: 'photo',
};

export const FB_AND_INSTA_CAROUSEL = {
    channel: CHANNELS.FB_AND_INSTA,
    creativeType: 'carousel',
};

export const FB_SINGLE = {
    channel: CHANNELS.FACEBOOK,
    creativeType: 'photo',
};

export const FB_CAROUSEL = {
    channel: CHANNELS.FACEBOOK,
    creativeType: 'carousel',
};

export const INSTA_SINGLE = {
    channel: CHANNELS.INSTAGRAM,
    creativeType: 'photo',
};

export const INSTA_CAROUSEL = {
    channel: CHANNELS.INSTAGRAM,
    creativeType: 'carousel',
};

export const GOOGLE_SEARCH = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'ExpandedTextAd',
};

export const GOOGLE_DISPLAY = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'ResponsiveDisplayAd',
};

export const GOOGLE_DISPLAY_EXTERNAL = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'ResponsiveDisplayAd',
    isCustom: true,
};
export const GOOGLE_DISPLAY_INTERNAL = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'ResponsiveDisplayAd',
    isCustom: false,
};

export const GOOGLE_LEGACY_DISPLAY = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'LegacyResponsiveDisplayAd',
};

export const GOOGLE_UNIVERSAL = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'universalApp',
};

export const GOOGLE_UNIVERSALV2 = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'universalAppV2',
};

export const GOOGLE_VIDEO = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'VIDEO_AD',
};
export const GOOGLE_IMAGE = {
    channel: CHANNELS.GOOGLE,
    creativeType: 'IMAGE_AD',
};
export const APPLE_SEARCH = {
    channel: CHANNELS.APPLE,
    creativeType: 'search',
};

export const KAKAO_IMAGE = {
    channel: CHANNELS.KAKAO,
    creativeType: 'image',
};

export const MICROSOFT_BING = {
    channel: CHANNELS.MICROSOFT,
    creativeType: 'ExpandedTextAd',
};

export const YELP_SEARCH = {
    channel: CHANNELS.YELP,
    creativeType: 'yelp',
};

export const YOUTUBE_VIDEO = {
    channel: CHANNELS.YOUTUBE,
    creativeType: 'video',
};

export const INPUT_TYPE_TEXTAREA_PROPS = {
    attrs: {
        type: 'textarea',
        isLimitLine: true,
        cleaner: R.replace(/\n/gi, ''),
        resizable: false,
    },
};

export const CAMPAIGN_UPDATE_TYPE = {
    UPDATE_CREATIVE: 'update_creative',
    UPDATE_AUDIENCE: 'update_target',
    UPDATE_BUDGET: 'update_budget',
    UPDATE_SCHEDULE: 'update_schedule',
    UPDATE_PLAN: 'update_plan',
};

export const DEFAULT_SVG_VIEWBOX = '0 0 24 24';

export const BUSINESS_PAGES = deepFreeze({
    kr: 'https://www.adriel.com/ko',
    en: 'https://www.adriel.com/en',
});

export const CONNECTION_TYPES = {
    PIXEL: 'facebookPixel',
    GA: 'googleAnalytics',
    FB_PAGE: 'facebookPage',
    FB_APP: 'fbApp',
    INSTAGRAM_PAGE: 'instagram',
    YELP_ACCOUNT: 'yelpAccount',
    YOUTUBE_CHANNEL: 'youtubeChannel',
    GOOGLE_AD_ACCOUNT: 'googleAdAccount',
    FACEBOOK_AD_ACCOUNT: 'facebookAdAccount',
    MICROSOFT_AD_ACCOUNT: 'microsoftAdAccount',
    NAVER_AD_ACCOUNT: 'naverAdAccount',
    KAKAO_AD_ACCOUNT: 'kakaoAdAccount',
    AMAZON_AD_ACCOUNT: 'amazonAdAccount',
    LINKEDIN_AD_ACCOUNT: 'linkedinAdAccount',
    TIKTOK_AD_ACCOUNT: 'tiktokAdAccount',
    TWITTER_AD_ACCOUNT: 'twitterAdAccount',
    SNAPCHAT_AD_ACCOUNT: 'snapchatAdAccount',
    CRITEO_AD_ACCOUNT: 'criteoAdAccount',
    APPSFLYER_APP: 'appsFlyer',
    YAHOO_AD_ACCOUNT: 'yahooAdAccount',
    APPLE_AD_ACCOUNT: 'appleAdAccount',
    BRANCH_APP: 'branch',
    PINTEREST_AD_ACCOUNT: 'pinterestAdAccount',
    GOOGLE_SHEETS: 'googleSpreadSheet',
    APPSTORECONNECT_ACCOUNT: 'appStoreConnectAccount',
    PLAYSTORE_ACCOUNT: 'playStoreAccount',
    REDDIT_AD_ACCOUNT: 'redditAdAccount',
    NAVER_GFA: 'naverGFAAdAccount',
    MAILCHIMP_AD_ACCOUNT: 'mailchimpAdAccount',
    ADVERITY: 'adverity',
    GA4: 'googleAnalytics4',
    INTERNAL: 'internal',
    AIRBYTE: 'airbyte',
};

export const DEFAULT_WEB_OR_APP = Object.freeze({
    type: 'web',
    appStoreUrl: '',
    developerSiteUrl: '',
    playStoreUrl: '',
    websiteUrl: '',
});

export const STRATEGIES = Object.freeze({
    NORMAL_PROPOSAL_REQUEST: 'normalProposalRequest',
    NORMAL_SELF_MADE_CAMPAIGN: 'normalSelfMadeCampaign',
    WEB_CAMPAIGN: 'webCampaign',
    MOBILE_APP_INSTALL_CAMPAIGN: 'mobileAppInstallCampaign',
    YELP_CAMPAIGN: 'yelpCampaign',
    SESSION_RECORD: 'sessionRecord',
    MATERIAL_SERVICE: 'materialService',
    USER_GUIDE: 'userGuide',
});

export const STRATEGY_LOCATIONS = {
    MY_CAMPAIGNS: 'MY_CAMPAIGNS',
};

export const ACCOUNT_ROLES = {
    ADMIN: 'ADMIN',
    NORMAL: 'NORMAL',
    ANALYST: 'ANALYST',
};

export const ACCOUNT_TYPES = {
    PLAN_T: 'T',
    PLAN_A: 'A',
};
export const ACCOUNT_ROLES_NEW = Object.freeze({
    ADMIN: 'admin',
    ONLY_VIEW: 'view_only',
    VIEW_AND_EDIT: 'view_and_edit',
    CONNECTION_MANAGEMENT: 'connection_management',
});

export const DAYS_OF_WEEK = {
    ko: ['일', '월', '화', '수', '목', '금', '토'],
    en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    ja: ['日', '月', '火', '水', '木', '金', '土'],
};

export const MONTH_NAMES = {
    ko: R.times((idx) => `${R.inc(idx)}월`, 12),
    en: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    ja: R.times((idx) => `${R.inc(idx)}月`, 12),
};

export const OBJECTIVES = {
    APP_INSTALLS: 'APP_INSTALLS',
    BRAND_AWARENESS: 'BRAND_AWARENESS',
    CONVERSIONS: 'CONVERSIONS',
    EVENT_RESPONSES: 'EVENT_RESPONSES',
    LEAD_GENERATION: 'LEAD_GENERATION',
    LINK_CLICKS: 'LINK_CLICKS',
    LOCAL_AWARENESS: 'LOCAL_AWARENESS',
    MESSAGES: 'MESSAGES',
    OFFER_CLAIMS: 'OFFER_CLAIMS',
    PAGE_LIKES: 'PAGE_LIKES',
    POST_ENGAGEMENT: 'POST_ENGAGEMENT',
    PRODUCT_CATALOG_SALES: 'PRODUCT_CATALOG_SALES',
    REACH: 'REACH',
    VIDEO_VIEWS: 'VIDEO_VIEWS',
};

export const ACCOUNT_ROLE_OPTIONS = [
    ACCOUNT_ROLES.ADMIN,
    ACCOUNT_ROLES.NORMAL,
    ACCOUNT_ROLES.ANALYST,
];

export const ADMIN_ROLE = {
    value: [ACCOUNT_ROLES_NEW.ADMIN],
    label: 'MULTI_ACCOUNT.role_admin',
};
export const ONLY_VIEW_ROLE = {
    value: [ACCOUNT_ROLES_NEW.ONLY_VIEW],
    label: 'MULTI_ACCOUNT.role_view_only',
};
export const VIEW_AND_EDIT_ROLE = {
    value: [ACCOUNT_ROLES_NEW.VIEW_AND_EDIT],
    label: 'MULTI_ACCOUNT.role_view_and_edit_after',
};
export const VIEW_AND_EDIT_WITH_MANAGEMENT_ROLE = {
    value: [
        ACCOUNT_ROLES_NEW.VIEW_AND_EDIT,
        ACCOUNT_ROLES_NEW.CONNECTION_MANAGEMENT,
    ],
    label: 'MULTI_ACCOUNT.role_view_and_edit',
};

export const ACCOUNT_ROLE_OPTIONS_NEW = [
    ADMIN_ROLE,
    VIEW_AND_EDIT_WITH_MANAGEMENT_ROLE,
    ONLY_VIEW_ROLE,
    // VIEW_AND_EDIT_ROLE,
];

export const MEMBER_STATUS = {
    CONNECTED: 'connected',
    PENDING: 'pending',
};

export const LOCAL_STORAGE_KEYS = {
    GRAPH_TAB: 'ADRIEL_GRAPH_TAB',
};

export const SUBSCRIPTION_STATUS = {
    AVAILABLE: 'AVAILABLE',
    ENDED: 'ENDED',
    ENDING_SOON: 'ENDING_SOON',
};

export const SUBSCRIPTION_STATUS_TYPE = {
    PAST_DUE: 'past_due',
    TRIALING: 'trialing',
    CANCELED: 'canceled',
    // PAID: 'paid',
    UNPAID: 'unpaid',
    INCOMPLETE: 'incomplete',
    INCOMPLETE_EXPIRED: 'incomplete_expired',
    ACTIVE: 'active',
};

export const WIDGET_TYPES = {
    AI_INSIGHT: 'aiInsight',
    ALARMS: 'alarms',
    PIVOT_TABLE: 'pivotTable', // sub
    GRAPH: 'graph',
    OVERVIEW: 'graphBoxes',
    OVERVIEW_CHILD: 'overviewChild',
    CREATIVE: 'creative',
    NOTEPAD: 'notepad',
    SINGLE_METRIC: 'singleMetric',
    SMALL_TABLE: 'smallTable',
    GOAL: 'goal',
    GOAL_CHILD: 'goalChild',
    AB_TESTING: 'abTesting',
    FILTER: 'filter',

    /** deprecated */
    METRIC_BOXES: 'metricBoxes',
    PIVOT_TABLE_ANALYTIC: 'pivotTableAnalytics',

    DATA_STERAM: 'dataStream',
    AUTOMATION: 'automation', // automation page
};

export const CHART_TYPES = Object.freeze({
    BAR: 'bar',
    HORIZONTAL_BAR: 'horizontal_bar',
    LINE: 'line',
    COMBO_CHART: 'combo_chart',
    SCATTER: 'scatter',
    PIE: 'pie',
    DONUT: 'donut',
    WORD_CLOUD: 'wordCloud',
    COLOR_CLUSTERING: 'color_clustering',
    EMOJI_ANALYSIS: 'emoji_analysis',
    FUNNEL: 'funnel',
    CHOROPLETH_MAP: 'choropleth_map',
});

export const SUBSCRIPTION_PLANS = {
    // STRIPE
    PROFESSIONAL: 'PROFESSIONAL',
    ENTERPRISE: 'ENTERPRISE',

    // NICEPAY

    LITE: 'LITE',

    // BOTH NICE & STRIPE
    BASIC: 'BASIC', // Trial
    CUSTOM: 'CUSTOM',
    TEAM: 'TEAM',
    // APPSUMO_TIER_1: 'APPSUMO_TIER_1',
    // APPSUMO_TIER_2: 'APPSUMO_TIER_2',
    // PLAN_1: 'PLAN_1',
    // PLAN_2: 'PLAN_2',
    // PLAN_3: 'PLAN_3',
};

export const PP_KEY = 'PREMIUM_PROPOSAL_PP_AD';

export const WIDGET_ACTION_TYPES = {
    SETTING: 'SETTING',
    DOWNLOAD: 'DOWNLOAD',
    COMMENT: 'COMMENT',
    ADD: 'ADD',
    DUPLICATE: 'DUPLICATE',
    REMOVE: 'REMOVE',
    RENAME: 'RENAME',
};

export const STREAM_CHAT_FILTER_VIEW_OPTIONS = {
    ALL: 'All',
    CURRENT: 'Current',
};

export const STREAM_CHAT_FILTER_THREAD_OPTIONS = {
    ALL: 'All',
    MENTIONS_YOU: 'Mentions You',
    OPEN: 'Open',
    RESOLVED: 'Resolved',
};

export const FILTER_KEYS = {
    TITLE: 'titles',
    STATUS: 'status',
    CHANNEL: 'channels',
    ID: 'ids',
    AD_ACCOUNT_ID: 'adAccountIds',
    UTM: 'utms',
    LABEL: 'breakdownLabels',
    OS: 'operatingSystems',
    OBJECTIVE: 'objectives',
    PLATFORM: 'subChannel',
    GENERIC: 'generic',
};

export const FILTER_STREAM_STATUS = {
    INIT: 'INIT',
    UPDATE: 'UPDATE',
    COMPLETE: 'COMPLETE',
};

export const PANEL_OPTION_KEYS = {
    BREAKDOWN: 'BREAKDOWN',
    CREATIVE_BREAKDOWN: 'CREATIVE_BREAKDOWN',
    DASHBOARD_FILTER: 'DASHBOARD_FILTER',
    WIDGET_FILTER: 'WIDGET_FILTER',
    DATA_SOURCE: 'DATA_SOURCE',
    SINGULAR_METRIC: 'SINGULAR_METRIC',
    TABLE_METRIC: 'TABLE_METRIC',
    GRAPH_OPTIONS: 'GRAPH_OPTIONS',
    GRAPH_DISPLAY_OPTIONS: 'GRAPH_DISPLAY_OPTIONS',
    TABLE_OPTIONS: 'TABLE_OPTIONS',
    MEMBER_SELECTOR: 'MEMBER_SELECTOR',
    DATE_FILTER: 'DATE_FILTER',
    GOAL_METRICS: 'GOAL_METRICS',
    FORECAST: 'FORECAST',
    METRIC_FILTER: 'METRIC_FILTER',
    COMPARISON_BY_DATE: 'COMPARISON_BY_DATE',
    ADVANCED_METRIC_FILTER: 'ADVANCED_METRIC_FILTER',
    ONOFF: 'ONOFF',
    CREATIVE_CNT: 'creativeCnt',
    GRAPH_GRID: 'GRAPH_GRID',
    GRAPH_LABEL: 'GRAPH_LABEL',
    TRENDLINE: 'TRENDLINE',
    FILTER_WIDGET_OPTIONS: 'FILTER_WIDGET_OPTIONS',
    BLEND_SETTING_TOGGLE: 'BLEND_SETTING_TOGGLE',
    TABLE_TRANSPOSE_TOGGLE: 'TABLE_TRANSPOSE_TOGGLE',
    AXES_CONFIG: 'AXES_CONFIG',
    COMBO_AXES_CONFIG: 'COMBO_AXES_CONFIG',

    // metric& breakdown with exposure list
    SORTING_METRIC_EXPOSURE: 'SORTING_METRIC_EXPOSURE',

    QUICK_MENU_VISIBLE: 'QUICK_MENU_VISIBLE',
};

export const FILTER_ITEM_CLASS = 'filter-option-item';

export const VIEW_DEFAULT_DATE_FILTR = {
    type: 'relative',
    values: {
        relative: { unit: 'D', value: 30 },
    },
    todayExcluded: true,
};

export const SMALL_TABLE_MAP = {
    channel: 'channel',
    adAccount: 'text',
    status: 'text',
    platform: 'text',
    placement: 'text',
    age: 'icon',
    gender: 'icon',
    deviceTarget: 'icon',
    os: 'text',
    month: 'text',
};

const {
    OVERVIEW,
    ALARMS,
    GRAPH,
    PIVOT_TABLE: TABLE,
    CREATIVE,
    NOTEPAD,
    SINGLE_METRIC,
    SMALL_TABLE,
    GOAL,
} = WIDGET_TYPES;

export const VIEW_DEFAULT_LAYOUT_CONFIG = {
    [ALARMS]: { x: 0, y: 0, w: 6, h: 5, i: '', moved: false, static: false },
    [OVERVIEW]: { x: 0, y: 0, w: 3, h: 8, i: '', moved: false, static: false },
    [TABLE]: { x: 0, y: 0, w: 6, h: 10, i: '', moved: false, static: false },
    [GRAPH]: { x: 0, y: 0, w: 6, h: 16, i: '', moved: false, static: false },
    [NOTEPAD]: { x: 0, y: 0, w: 3, h: 7, i: '', moved: false, static: false },
    [SINGLE_METRIC]: {
        x: 0,
        y: 0,
        w: 1,
        h: 5,
        i: '',
        moved: false,
        static: false,
    },
    [CREATIVE]: {
        x: 0,
        y: 0,
        w: 6,
        h: 18,
        i: '',
        moved: false,
        static: false,
    },
    [SMALL_TABLE]: {
        x: 0,
        y: 0,
        w: 2,
        h: 10,
        i: '',
        moved: false,
        static: false,
    },
    [GOAL]: {
        x: 0,
        y: 0,
        w: 2,
        h: 10,
        i: '',
        moved: false,
        static: false,
    },
};

export const LAYOUT_H_HEIGHT = 16;
export const WIDGET_HEADER_HEIGHT = 50;

export const WIDGET_ADD_TYPE = {
    ADD_TO_TOP: 'ADD_TO_TOP',
    ADD_TO_BOTTOM: 'ADD_TO_BOTTOM',
    DUPLICATION: 'DUPLICATION',
};

export const INDEX_KEY_FOR_FILTER = {
    adAccount: 'channelAdAccountId',
    channel: 'name',
    campaign: 'channelCampaignId',
    adSet: 'channelAdSetId',
    ad: 'channelAdId',
};

export const LINE_CLAMP_DIR = {
    directives: [
        {
            name: 'line-clamp',
            value: 2,
        },
    ],
};

export const EXCEPTED_METRICS = [
    'spendOnActions',
    'clicksOnActions',
    'bouncedVisits',
    'totalVisitDuration',
    'totalPageViews',
    'facebookSpend',
    'videoImpressions',
    'spendOnViews',
    'lifeTimeSpend',
    'starts',
    'ends',
    'adAccountName',

    // additional
    'utm',
    'wordTotalCountUnique',
    'defaultValue',
    'channelCampaignIds',
    'channelAdSetIds',
    'channelAdIds',
    'channelAdAccountId',
    'channelCampaignId',
    'channelAdSetId',
    'channelAdId',
    'channelKeywordId',
    'channelAdAccountIds',
    'channelKeywordIds',

    // from refined metrics
    'adId',
    'adSetId',
    'adName',
    'adSetName',
    'allConversionsValue',
    'channelSubType',
];

export const NON_NUMERIC_VALUE_METRIC = [
    'bidStrategies',
    'bidStrategy',
    'subChannels',
    'objectives',
    'channelKeywordId',
    'channelAdAccountId',
    'keywordName',
    'budget',
    'resultIndicator',
    'adName',
    'campaignId',
    'campaignName',
    'campaignNames',
    'targetingType',
    'adAccountName',
    'starts',
    'adId',
    'status',
    'adSetId',
    'adSetName',
    'ends',
    'bidCap',
    'bidStrategy',
    'level',
    'channel',
    'channelType',
    'channelSubType',
    'objective',
    'utmTerm',
    'utmCampaign',
    'utmSource',
    'utmMedium',
    'utmContent',
    'utmTerm',
    'campaignStatus',
    'adSetStatus',
    'adStatus',
];

export const EMPTY_OBJ = Object.freeze({});

export const WIDGET_KEY_INFO = {
    overview: {
        id: WIDGET_TYPES.OVERVIEW, // for default layout data
        type: 'graph_box', // for add widget
        name: 'graph_box', // for text
        iconName: 'widget_icon_overview.webp',
    },
    singleMetricWidget: {
        id: WIDGET_TYPES.SINGLE_METRIC,
        type: 'singleMetric',
        name: 'singleMetric',
        iconName: 'widget_icon_single_metric.webp',
    },
    alarm: {
        id: WIDGET_TYPES.ALARMS,
        type: 'alarm',
        name: 'alarm',
        iconName: 'widget_icon_alarm.webp',
    },
    creative: {
        id: WIDGET_TYPES.CREATIVE,
        type: WIDGET_TYPES.CREATIVE,
        name: WIDGET_TYPES.CREATIVE,
        iconName: 'widget_icon_creative.webp',
    },
    notepad: {
        id: WIDGET_TYPES.NOTEPAD,
        type: 'notepad',
        name: 'notepad',
        iconName: 'widget_icon_notepad.webp',
    },
    goal: {
        id: WIDGET_TYPES.GOAL,
        type: 'goal',
        name: 'goal',
        iconName: 'widget_icon_goal.webp',
    },
    tableBlock: {
        id: 'table',
        type: 'block',
    },
    pivotTable: {
        id: WIDGET_TYPES.PIVOT_TABLE,
        type: 'pivot',
        name: 'analyticTable',
        subType: 'pivot',
        iconName: 'widget_icon_table_ads.webp',
    },
    analyticPivotTable: {
        id: WIDGET_TYPES.PIVOT_TABLE,
        type: 'pivot',
        name: 'analyticTable',
        subType: 'analytic',
        iconName: 'widget_icon_table_analytic.webp',
    },
    smallTable: {
        id: WIDGET_TYPES.SMALL_TABLE,
        type: 'smallTable',
        name: 'smallTable',
        iconName: 'widget_icon_smallTable.webp',
    },
    graphBlock: {
        id: 'graph',
        type: 'block',
    },
    graphBar: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.BAR,
        iconName: 'widget_icon_graph_bar.webp',
    },
    graphHorizontalBar: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.HORIZONTAL_BAR,
        iconName: 'widget_icon_horizontal.webp',
    },
    graphLine: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.LINE,
        iconName: 'widget_icon_graph_line.webp',
    },
    comboChart: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.COMBO_CHART,
        iconName: 'widget_icon_combo_chart.webp',
    },
    graphScatter: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.SCATTER,
        iconName: 'widget_icon_graph_scatter.webp',
    },
    graphPie: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.PIE,
        iconName: 'widget_icon_graph_pie.webp',
    },
    graphDonut: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.DONUT,
        iconName: 'widget_icon_donut_chart.webp',
    },
    graphWordCloud: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.WORD_CLOUD,
        iconName: 'widget_icon_graph_word_cloud.webp',
    },
    graphColorClustering: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.COLOR_CLUSTERING,
        iconName: 'widget_icon_graph_color_clustering.webp',
    },
    graphEmoji: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.EMOJI_ANALYSIS,
        iconName: 'widget_icon_graph_emoji.webp',
    },
    graphFunnel: {
        id: WIDGET_TYPES.GRAPH,
        type: 'graph',
        name: 'graph',
        subType: CHART_TYPES.FUNNEL,
        iconName: 'widget_icon_graph_funnel.webp',
    },
};

export const GRID_LAYOUT_NUM_OF_COLUMN = 6;

export const SELECTION_NONE = null;
export const ASC = 'asc';
export const DESC = 'desc';
export const DEFAULT_DATA_LIMIT = 10;

export const COUNTRY_BREAKDOWN = 'country';
export const STATE_US_ONLY_BREAKDOWN = 'USState';

export const GRAPH_FILTER_TYPES = Object.freeze({
    GRAPH: 'selectedGraphType',
    YAXIS: 'selectedMetric',
    COMBO_METRICS: 'comboChart',
    COMBO_YAXIS_1: 'comboYAxis1',
    COMBO_YAXIS_2: 'comboYAxis2',
    COMBO_YAXIS_3: 'comboYAxis3',
    XAXIS: 'selectedxAxis',
    DATE_BREAKDOWN: 'dateBreakdown',
    BREAKDOWN: 'selectedDimensionId',
    BUBBLE_SIZE: 'selectedBubbleSize',
    SORT: 'sort',
    LIMIT: 'limit',
    HIDE_OTHERS: 'hideOthers',
    GEO_BREAKDOWN: 'geoBreakdown',
    GEO_MAP_TYPE: 'geoMapType',
});

export const GEO_MAP_TYPES = {
    WORLD: 'world',
    US_STATE: 'usstate',
};

export const GRAPH_OPTION_DEFAULT_VALUE = {
    [GRAPH_FILTER_TYPES.GRAPH]: CHART_TYPES.BAR,
    [GRAPH_FILTER_TYPES.YAXIS]: undefined,
    [GRAPH_FILTER_TYPES.XAXIS]: undefined,
    [GRAPH_FILTER_TYPES.COMBO_METRICS]: {
        yAxis1: { metric: undefined, type: 'bar' },
        yAxis2: { metric: undefined, type: 'bar' },
        yAxis3: { metric: undefined, type: 'line' },
    },
    [GRAPH_FILTER_TYPES.DATE_BREAKDOWN]: undefined,
    [GRAPH_FILTER_TYPES.BUBBLE_SIZE]: undefined,
    [GRAPH_FILTER_TYPES.SORT]: {
        isDesc: true,
    },
    [GRAPH_FILTER_TYPES.LIMIT]: DEFAULT_DATA_LIMIT,
    [GRAPH_FILTER_TYPES.HIDE_OTHERS]: false,
};

export const FILTER_WIDGET_OPTIONS_DEFAULT_VALUE = {
    linkedWidgetIds: null,
    allowMultiSelect: false,
    sortAlphabetically: false,
    availableLabels: null,
    subType: 'fieldValue',
    groupId: undefined,
    by: undefined,
    condition: undefined,
};

export const DEFAULT_PRICE_PLAN_SETTINGS = {
    // nbOfConnections: number;
    // nbOfUsers: number;
    // nbOfViews: number;
    // availableConnectorTypes: Array<string>;
    // availableWidgetTypes: Array<Widget>;
    // allowAllConnectorTypes: boolean;
    // allowAllWidgetTypes: boolean;
    allowAdverity: true,
    allowAirbyte: true,
    allowDataSourceSettings: true,
    allowCustomAlarms: true,
    allowMMO: false,
    allowDataTransfer: false,
};

export const IFRAME_EVENT_MESSAGE = {
    ADD_NOTI_MSGS: 'ADD_NOTI_MSGS',
    SET_NOTI_MSGS: 'SET_NOTI_MSGS',
    REPLACE_NOTI_MSGS: 'REPLACE_NOTI_MSGS',
    REMOVE_NOTI_MSG: 'REMOVE_NOTI_MSG',
    SET_TOAST_MSG: 'SET_TOAST_MSG',
    OPEN_NEW_WINDOW_WITH_FILTERS: 'OPEN_NEW_WINDOW_WITH_FILTERS',
    CLICK_CONNECTION_MENU_ITEM: 'CLICK_CONNECTION_MENU_ITEM',
    CLICK_NDA_CONTACT_US: 'CLICK_NDA_CONTACT_US',
    CLICK_CONTACT_SUPPORT_PREMIUM_DATA_STREAM:
        'CLICK_CONTACT_SUPPORT_PREMIUM_DATA_STREAM',
    CLICK_CONNECT_RECOMMENDED_CONNECTION_ITEM:
        'CLICK_CONNECT_RECOMMENDED_CONNECTION_ITEM',
    CLICK_COPY_CONNECTION_SHARE_LINK: 'CLICK_COPY_CONNECTION_SHARE_LINK',
    CLICK_DISCONNECT_ASSET_CONNECTION: 'CLICK_DISCONNECT_ASSET_CONNECTION',
    CLICK_RECONNECT_ASSET_CONNECTION: 'CLICK_RECONNECT_ASSET_CONNECTION',
    SYNC_CONNECTED_ASSETS: 'SYNC_CONNECTED_ASSETS',
    CLICK_DELETE_ASSET_CONNECTION: 'CLICK_DELETE_ASSET_CONNECTION',
    PAGE_LOAD_EVENT: 'PAGE_LOAD_EVENT',
    RENDER_LITE_VERSION_DIALOG: 'RENDER_LITE_VERSION_DIALOG',
    SAVE_VIEW: 'SAVE_VIEW',
    UPDATE_FOLDER_PERMISSIONS: 'UPDATE_FOLDER_PERMISSIONS',
    SAVE_WIDGET: 'SAVE_WIDGET',
    SAVE_CURRENT_VIEW_TO_SERVER: 'SAVE_CURRENT_VIEW_TO_SERVER',
    OPEN_WIDGET_ERROR_PANEL: 'OPEN_WIDGET_ERROR_PANEL',
    REFRESH_WIDGET_DATA: 'REFRESH_WIDGET_DATA',
    REFRESH_CHILDREN_DATA: 'REFRESH_CHILDREN_DATA',
    MOVE_TO_OTHER_PAGE: 'MOVE_TO_OTHER_PAGE',
    SYNC_ROUTE: 'SYNC_ROUTE',
    OPEN_CREATIVE_MODAL: 'OPEN_CREATIVE_MODAL',
    PUSH_TO_ROUTE: 'PUSH_TO_ROUTE',
    CHANGE_ACCOUNT: 'CHANGE_ACCOUNT',
    SWITCH_WORKSPACE_IN_PLACE: 'SWITCH_WORKSPACE_IN_PLACE',
    CLICK_ALL_DASHBOARD_COMMENTS: 'CLICK_ALL_DASHBOARD_COMMENTS',
    SHOW_LOGOUT_MODAL: 'SHOW_LOGOUT_MODAL',
    USER_DEACTIVATED: 'USER_DEACTIVATED',
    // React → Vue: a two-factor change made the session stale; sign out (no toast)
    MFA_SESSION_INVALIDATED: 'MFA_SESSION_INVALIDATED',
    // Vue → React: a forced sign-out has started; React's beforeunload guard stands down
    SESSION_ENDED: 'SESSION_ENDED',
    // React → Vue: "Contact us" in Settings two-factor; open the support center
    OPEN_SUPPORT_CENTER: 'OPEN_SUPPORT_CENTER',
    OPEN_CONNECTION_PANEL: 'OPEN_CONNECTION_PANEL',
    OPEN_WIDGET_COMMENT: 'OPEN_WIDGET_COMMENT',
    CLOSE_VUE_PANNELS: 'CLOSE_VUE_PANNELS',
    CLOSE_MEMBER_SELECTOR_PANEL: 'CLOSE_MEMBER_SELECTOR_PANEL',
    RELOAD_WITH_NO_CACHE: 'RELOAD_WITH_NO_CACHE',
    OPEN_SIDEBAR: 'OPEN_SIDEBAR',
    // ACTIVATE_WINDOW_SCROLL: 'ACTIVATE_WINDOW_SCROLL',
    TOGGLE_HEADER: 'TOGGLE_HEADER',
    OPEN_DATA_SOURCE_SECOND_PANEL: 'OPEN_DATA_SOURCE_SECOND_PANEL',
    CLOSE_TABLE_METRIC_SECOND_PANEL: 'CLOSE_TABLE_METRIC_SECOND_PANEL',
    TOP_BTN_SHOW: 'TOP_BTN_SHOW',
    TOP_BTN_HIDE: 'TOP_BTN_HIDE',
    REFRESH_PERMISSION_DATA: 'REFRESH_PERMISSION_DATA',
    IS_TAKE_SNAPSHOT_LOADING: 'IS_TAKE_SNAPSHOT_LOADING',
    AUTOMATION_DATA_SOURCE_ON_UPDATE: 'AUTOMATION_DATA_SOURCE_ON_UPDATE',
    AUTOMATION_TABLE_METRIC_ON_UPDATE: 'AUTOMATION_TABLE_METRIC_ON_UPDATE',
    ADGEN_DATA_SOURCE_ON_UPDATE: 'ADGEN_DATA_SOURCE_ON_UPDATE',
    OPEN_CONNECT_SIDE_PANEL: 'OPEN_CONNECT_SIDE_PANEL',
    CLOSE_CONNECT_SIDE_PANEL: 'CLOSE_CONNECT_SIDE_PANEL',
    CONNECT_SIDE_PANEL_IS_READY: 'CONNECT_SIDE_PANEL_IS_READY',
    Loaded_New_Template: 'Loaded_New_Template',
    START_USER_FLOW: 'START_USER_FLOW',
    HIDE_CHATBOT: 'HIDE_CHATBOT',
    SHOW_CHATBOT: 'SHOW_CHATBOT',
    OPEN_HELP_DESK: 'OPEN_HELP_DESK',
    TOGGLE_WIDGET_DATE_FILTER: 'TOGGLE_WIDGET_DATE_FILTER',
    POST_RECT_FOR_OVERLAY: 'POST_RECT_FOR_OVERLAY',
    SAVE_WIDGET_DATE_FILTER: 'SAVE_WIDGET_DATE_FILTER',
    CLOSE_ALL_SECOND_PANEL: 'CLOSE_ALL_SECOND_PANEL',
    FORCE_FETCH_CONNECTED_ASSETS: `FORCE_FETCH_CONNECTED_ASSETS`,
    REFRESH_ACCESS_TOKEN: 'REFRESH_ACCESS_TOKEN',
    REFRESH_ACCESS_TOKEN_RESPONSE: 'REFRESH_ACCESS_TOKEN_RESPONSE',
    REFRESH_ACCESS_TOKEN_ERROR: 'REFRESH_ACCESS_TOKEN_ERROR',
    SYNC_CHATBOT_VISIBILITY: 'SYNC_CHATBOT_VISIBILITY',
    UPDATE_SNACKBAR_SAFE_BOTTOM: 'UPDATE_SNACKBAR_SAFE_BOTTOM',
    ROUTER_BACK: 'ROUTER_BACK',
    TOGGLE_GOAL_WIDGET_RANGE_SETTING: 'TOGGLE_GOAL_WIDGET_RANGE_SETTING',
    UPDATE_GOAL_WIDGET_RANGE_SETTING: 'UPDATE_GOAL_WIDGET_RANGE_SETTING',
    OPEN_GLOBAL_TOAST: 'OPEN_GLOBAL_TOAST',

    TRIGGER_TABLE_DOWNLOAD: 'TRIGGER_TABLE_DOWNLOAD',
    TRIGGER_TABLE_XLSX_DOWNLOAD: 'TRIGGER_TABLE_XLSX_DOWNLOAD',

    // Plan & Billing — React → Vue
    OPEN_ADD_PAYMENT_MODAL: 'OPEN_ADD_PAYMENT_MODAL',
    OPEN_CREDIT_CHARGE_MODAL: 'OPEN_CREDIT_CHARGE_MODAL',

    // Plan & Billing — Vue → React
    PAYMENT_METHOD_ADDED: 'PAYMENT_METHOD_ADDED',
    CREDIT_CHARGED: 'CREDIT_CHARGED',

    /**
     * Widget Setting Panel related events
     */
    OPEN_WIDGET_SETTING_PANEL: 'OPEN_WIDGET_SETTING_PANEL',

    OPEN_EXPOSURE_LIST_PANEL: 'OPEN_EXPOSURE_LIST_PANEL',

    TOGGLE_WIDGET_FILTER: 'TOGGLE_WIDGET_FILTER',
    UPDATE_WIDGET_FILTER: 'UPDATE_WIDGET_FILTER',

    TOGGLE_METRIC_PANEL: 'TOGGLE_METRIC_PANEL',
    TOGGLE_BREAKDOWN_PANEL: 'TOGGLE_BREAKDOWN_PANEL',
    TOGGLE_CUSTOM_BREAKDOWN_PANEL: 'TOGGLE_CUSTOM_BREAKDOWN_PANEL', // toggle custom breakdown panel from list filter wiget
    SET_IFRAME_LAYER: 'SET_IFRAME_LAYER',
    UPDATE_METRIC_PANEL: 'UPDATE_METRIC_PANEL',
    UPDATE_BREAKDOWN_PANEL: 'UPDATE_BREAKDOWN_PANEL',
    SYNC_METRIC_PANEL_API_PARAMS: 'SYNC_METRIC_PANEL_API_PARAMS',
    SYNC_BREAKDOWN_PANEL_API_PARAMS: 'SYNC_BREAKDOWN_PANEL_API_PARAMS',

    REFRESH_AD_ACCOUNTS: 'REFRESH_AD_ACCOUNTS',
    REFRESH_DIMENSIONS: 'REFRESH_DIMENSIONS',
    REFRESH_CUSTOM_METRICS: 'REFRESH_CUSTOM_METRICS',
    REFRESH_PREFERENCES: 'REFRESH_PREFERENCES',

    // Members
    OPEN_INVITE_MEMBER_MODAL: 'OPEN_INVITE_MEMBER_MODAL',
    OPEN_CREATE_WORKSPACE_MODAL: 'OPEN_CREATE_WORKSPACE_MODAL',

    // Edit Mode leave guard (Vue cooperation contract)
    CHECK_EDIT_MODE_DIRTY: 'CHECK_EDIT_MODE_DIRTY',
    EDIT_MODE_DIRTY_RESPONSE: 'EDIT_MODE_DIRTY_RESPONSE',
    EDIT_MODE_NAV_PROCEED: 'EDIT_MODE_NAV_PROCEED',
    SYNC_EDIT_MODE_GUARD_DIRTY: 'SYNC_EDIT_MODE_GUARD_DIRTY',
    NEW_VIEW_CREATED: 'NEW_VIEW_CREATED',

    // Unsaved-changes leave guard — page 중립 계약. 저장되지 않은 상태를 가진
    // 어떤 React 페이지든 mixins/unsavedChangesGuard + React의
    // useUnsavedChangesGuard 조합을 그대로 재사용한다. 위 EDIT_MODE_* 는 같은
    // 프로토콜의 대시보드 전용 사본이며, 흡수될 때까지 남겨둔다.
    CHECK_UNSAVED_CHANGES: 'CHECK_UNSAVED_CHANGES',
    UNSAVED_CHANGES_RESPONSE: 'UNSAVED_CHANGES_RESPONSE',
    UNSAVED_NAV_PROCEED: 'UNSAVED_NAV_PROCEED',
    SYNC_UNSAVED_GUARD: 'SYNC_UNSAVED_GUARD',
};

export const LITE_VERSION_ACTION_TYPE = {
    CLICK_MODAL_BTN: 'ClickModalLiteVersionButton',
    CLICK_INSERT_CARD_BTN: 'ClickInsertCardButton',
    CLICK_REFUND_POLICY: 'ClickRefundPolicy',
    CLICK_CONSENT_CHECK_BOX: 'ClickConsentCheckBox',
};

export const STRIPE_ACTION_TYPE = {
    POPUP_STRIPE_PAYMENT: 'POPUP_STRIPE_PAYMENT',
    CLICK_PROFESSIONAL: 'CLICK_PROFESSIONAL',
    CLICK_TEAM: 'CLICK_TEAM',
    CLICK_ENTERPRISE: 'CLICK_ENTERPRISE',
    CLICK_CUSTOM: 'CLICK_CUSTOM',
};

export const PAYMENT_TYPES = {
    STRIPE: 'stripe',
    NICE_PAY: 'nice',
    TRANSFER: 'transfer',
    USER_CARD: 'user_card',
    APP_SUMO: 'app_sumo',
    CREDITS: 'credits',
};

export const PAYMENT_USER_ACTION_TYPE = {
    NICE_PAY: 'nicepay-lite',
    STRIPE: PAYMENT_TYPES.STRIPE,
};

export const OPERATOR = {
    GREATER_THAN: '>',
    LESS_THAN: '<',
    EQUAL: '=',
};

export const CONTACT_FIELDS = ['name', 'phone'];
export const CONTACT_FORM_PLACEHOLDER = {
    name: '김광일',
    role: '마케팅 팀장',
    phone: '010 1234 5678',
};

export const CSM_ADS_OPTIONS = [
    '메타',
    '구글애즈',
    '네이버GFA',
    '네이버검색',
    '카카오모먼트',
    '카카오키워드',
    '틱톡',
    '링크드인',
    '트위터',
];

export const CUSTOM_LOGO_WORKSPACES = {
    509801: {
        name: 'ytone',
        logo: YtoneLogo,
        displayPoweredBy: true,
    },
};

const getWhitelabelLogoUrl = (workspaceId) => {
    return `https://app.adriel.com/s3/public/${workspaceId}/whitelabel/logo.png`;
};

const getWhitelabelFaviconUrl = (workspaceId) => {
    return `https://app.adriel.com/s3/public/${workspaceId}/whitelabel/favicon.ico`;
};

export const CUSTOM_LOGO_WHITELABEL_HOSTS = {
    'insights.adstudio.com': {
        title: '',
        logo: EcomLogo,
        link: 'https://www.ecomsystems.com/',
        fullLogoWhite: UnfiLogo,
    },
    'dashboard.boomingkorea.com': {
        title: '',
        logo: getWhitelabelLogoUrl(680301),
        favicon: getWhitelabelFaviconUrl(680301),
        workspaceId: 680301,
    },
    'www.himkt.co.kr': {
        title: '',
        logo: getWhitelabelLogoUrl(940961),
        favicon: getWhitelabelFaviconUrl(940961),
        workspaceId: 940961,
    },
    'bk.stg.adriel.com': {
        title: '',
        logo: UnfiLogo,
    },
    'app.adfuelreports.com': {
        title: '',
        logo: getWhitelabelLogoUrl(161621),
        link: 'https://goadfuel.com/',
        favicon: getWhitelabelFaviconUrl(161621),
        fullLogoWhite: AdfuelFullWhiteLogo,
        workspaceId: 161621,
    },
    'reports.creatorade.ca': {
        title: '',
        logo: getWhitelabelLogoUrl(911681),
        favicon: getWhitelabelFaviconUrl(911681),
        link: 'https://creatorade.ca/',
        workspaceId: 911681,
    },
    'dashboard.oxydigital.com.br': {
        title: 'OXY Agency',
        logo: getWhitelabelLogoUrl(1143641),
        favicon: getWhitelabelFaviconUrl(1143641),
        link: 'https://oxydigital.com.br/',
        workspaceId: 1143641,
    },
    'reporting.priceweber.com': {
        title: 'PriceWeber',
        logo: getWhitelabelLogoUrl(1073441),
        favicon: getWhitelabelFaviconUrl(1073441),
        link: 'https://priceweber.com/',
        workspaceId: 1073441,
    },
    'dashboard.aizy.nl': {
        title: 'Aizy',
        logo: getWhitelabelLogoUrl(1203981),
        favicon: getWhitelabelFaviconUrl(1203981),
        link: 'https://www.aizy.nl/',
        workspaceId: 1203981,
    },
    'dashboard.rocmedia.ca': {
        title: 'ROC MEDIA',
        logo: getWhitelabelLogoUrl(963661),
        favicon: getWhitelabelFaviconUrl(963661),
        fullLogoWhite: RocMediaFullWhiteLogo,
        link: 'https://www.rocmedia.ca/',
        workspaceId: 963661,
    },
    'dashboard.finch.com': {
        title: 'Finch',
        logo: getWhitelabelLogoUrl(1299761),
        favicon: getWhitelabelFaviconUrl(1299761),
        fullLogoWhite: FinchFullWhiteLogo,
        link: 'https://www.finch.com/',
        workspaceId: 1299761,
    },
    'reports.yourpipeline.pro': {
        title: 'Ignite Home Services',
        logo: getWhitelabelLogoUrl(1409781),
        favicon: getWhitelabelFaviconUrl(1409781),
        link: 'https://townsquareignite.com/',
        workspaceId: 1409781,
    },
    'dashboard.daehong.co.kr': {
        title: '대홍기획',
        logo: getWhitelabelLogoUrl(1376761),
        favicon: getWhitelabelFaviconUrl(1376761),
        link: 'https://www.daehong.com/',
        hideChatbot: true,
        workspaceId: 1376761,
    },
    'nexus.cartazero.co.jp': {
        title: 'CARTA ZERO',
        logo: getWhitelabelLogoUrl(1248041),
        favicon: getWhitelabelFaviconUrl(1248041),
        link: 'https://www.cartazero.co.jp/',
        workspaceId: 1248041,
    },
    'marcos.iris.infiniteroar.com': {
        title: 'IRIS - Marcos Pizza',
        logo: getWhitelabelLogoUrl(1429041),
        favicon: getWhitelabelFaviconUrl(1429041),
        fullLogoWhite: IrisFavicon,
        link: 'https://www.infiniteroar.com/',
        workspaceId: 1429041,
    },
    'magnolia.iris.infiniteroar.com': {
        title: 'Magnolia',
        logo: getWhitelabelLogoUrl(1567421),
        favicon: getWhitelabelFaviconUrl(1567421),
        fullLogoWhite: IrisFavicon,
        link: 'https://www.infiniteroar.com/',
        workspaceId: 1567421,
    },
    'jm.iris.infiniteroar.com': {
        title: "Jersey Mikes's",
        logo: getWhitelabelLogoUrl(1570501),
        favicon: getWhitelabelFaviconUrl(1570501),
        fullLogoWhite: IrisFavicon,
        link: 'https://www.infiniteroar.com/',
        workspaceId: 1570501,
    },
    'app.dysrupt.com': {
        title: 'Dysrupt',
        logo: getWhitelabelLogoUrl(798021),
        favicon: getWhitelabelFaviconUrl(798021),
        link: 'https://www.dysrupt.com/',
        workspaceId: 798021,
    },
    'ssi.iris.infiniteroar.com': {
        title: 'Stanley Steemer',
        logo: getWhitelabelLogoUrl(1623781),
        favicon: getWhitelabelFaviconUrl(1623781),
        fullLogoWhite: IrisFavicon,
        link: 'https://www.infiniteroar.com/',
        workspaceId: 1623781,
    },
    'reporting.digitaladlink.com': {
        title: 'Reporting',
        logo: getWhitelabelLogoUrl(1702761),
        favicon: getWhitelabelFaviconUrl(1702761),
        workspaceId: 1702761,
    },
    'dashboard.hingemarketing.com': {
        title: 'Dashboard',
        logo: getWhitelabelLogoUrl(1706281),
        favicon: getWhitelabelFaviconUrl(1706281),
        workspaceId: 1706281,
    },
    'reports.allytics.com': {
        title: 'Allytics',
        logo: getWhitelabelLogoUrl(1735141),
        favicon: getWhitelabelFaviconUrl(1735141),
        workspaceId: 1735141,
    },
    'kinetic.iris.infiniteroar.com': {
        title: 'IRIS - Kinetic',
        logo: getWhitelabelLogoUrl(1358261),
        favicon: getWhitelabelFaviconUrl(1358261),
        fullLogoWhite: IrisFavicon,
        link: 'https://www.infiniteroar.com/',
        workspaceId: 1358261,
    },
};

export const REACT_BASE_URL =
    window?.location?.hostname === 'localhost'
        ? process.env.VUE_APP_REACT_BASE_URL
        : window.location.origin + '/react';

export const TRANSFER_TYPES = {
    GoogleSheet: 'Google Sheets',
    MySQL: 'MySQL',
    Postgres: 'Postgres',
    S3: 'S3',
    Snowflake: 'Snowflake',
    BigQuery: 'BigQuery',
    API: 'API',
    GoogleSheetV2: 'Google Sheets v2', // deprecated
    // BigQueryV2: 'BigQuery v2', // deprecated
};

/**
 * Two-factor authentication (TOTP). Mirrors adriel_server MfaService and the
 * React `api/auth/mfa/constants.ts` values.
 */
export const MFA = {
    ROUTE_NAME: 'Sign/Mfa',
    /** Server MFA_CHALLENGE_TTL_SECONDS — how long a login challenge lives. */
    CHALLENGE_TTL_SEC: 300,
    /** Server challenge max attempts — wrong codes before the challenge is discarded. */
    CHALLENGE_MAX_ATTEMPTS: 3,
    METHOD: {
        TOTP: 'totp',
        BACKUP_CODE: 'backup_code',
    },
    ERROR: {
        INVALID_CODE: 'INVALID_MFA_CODE',
        INVALID_CHALLENGE: 'INVALID_MFA_CHALLENGE',
    },
    /**
     * "Contact {email}" on the login challenge. The address is the link text:
     * a page cannot tell whether a mail handler exists, and without one
     * `mailto:` does nothing (TASK-14311).
     */
    SUPPORT_EMAIL: 'support@adriel.com',
    CONTACT_URL: 'mailto:support@adriel.com',
    /**
     * Seconds the re-login notice and the login challenge's exit screens count
     * down before going to the login form. Same as React
     * `MFA_RELOGIN_COUNTDOWN_SEC` (Figma "다시 로그인 {5}").
     */
    RELOGIN_COUNTDOWN_SEC: 5,
    /** `?mfa=` values React Settings understands on the account tab. */
    SETTINGS_DEEPLINK: {
        SETUP: 'setup',
        REGENERATE: 'regenerate',
    },
};
